import { render, staticRenderFns } from "./ServiceCategoryCreateOrEdit.vue?vue&type=template&id=563b3819&"
import script from "./ServiceCategoryCreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./ServiceCategoryCreateOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCategoryCreateOrEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports